import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import { RbacProvider } from './RbacContext';

// Wraps the whole app so role + permissions from GET /me are available to every
// page, the sidebar, and the route guards via the useRbac() hook.
export const rbacModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    AppRootWrapperBlueprint.make({
      name: 'rbac-provider',
      params: {
        component: RbacProvider,
      },
    }),
  ],
});

export { RbacContext } from './RbacContext';
export type { RbacState } from './RbacContext';
export { useRbac, useHasPermission, useHasRole } from './hooks';
export { RequirePermission, RequireRole } from './guards';
